<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អ្នកទីផ្សារទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>

			<md-table v-if="referralList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>លេខទូរស័ព្ទ</md-table-head>
					<md-table-head>កំណត់ចំណាំ</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(referral, index) in referralList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
						{{ referral.hash_id }}
					</md-table-cell>
					<md-table-cell>{{ referral.name }}</md-table-cell>
					<md-table-cell>{{ referral.phone }}</md-table-cell>
					<md-table-cell>{{ referral.note }}</md-table-cell>
					<md-table-cell>{{ config.datelify(referral.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/referral/detail/' + referral.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/referral/edit/' + referral.hash_id">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="deleteReferral(referral.id)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
						</md-button>
						<!-- <md-button class="md-just-icon md-simple md-info">
							<md-icon>edit</md-icon>
							<md-tooltip md-direction="top">Edit client information</md-tooltip>
						</md-button>

						<md-button class="md-just-icon md-simple md-danger">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">Delete this client</md-tooltip>
						</md-button> -->
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="referralList.length == 0 && loadMore == true">មិនមានអ្នកទីផ្សារ</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអ្នកទីផ្សារ</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះអ្នកទីផ្សារ *</label>
								<md-input type="text" v-model="referral.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខទូរស័ព្ទអ្នកទីផ្សារ *</label>
								<md-input type="text" v-model="referral.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់សំគាល់</label>
								<md-input type="text" v-model="referral.description">
								</md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះអ្នកទីផ្សារ</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(referral.name).length > 0">{{referral.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទអ្នកទីផ្សារ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(referral.phone).length > 0">{{referral.phone}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់សំគាល់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(referral.description).length > 0">{{referral.description}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postReferral()">បង្កើត</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialog" md-title="តើអ្នកពិតជាចង់លុបអ្នកទីផ្សារនេះពិតមែនទេ ?"
		md-content="ព័ត៌មានរបស់អ្នកទីផ្សារនឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
		@md-cancel="onCancel" @md-confirm="deleteReferral" />
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteID: "",
				deleteDialog: false,
				search: {
					text: ""
				},
				referral: {
					name: "",
					phone: "",
					description: ""
				},
				loadMore: true,
				referralList: []

			}
		},
		methods: {
			postReferral() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/referral/post", {
					referral: this.referral
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អ្នកផ្ញើរឥវ៉ាន់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.searchHandler();
						this.clearAll();
					}
					// this.loadMoreCompanyButton = true

				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/referral/search", {
					text: this.search.text,
					offset: more ? this.referralList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.referralList = more ? this.referralList.concat(data.body.data) : data.body.data;
					// this.referralList = data.body.data;
				})
			},
			deleteReferral(id) {
				if (String(this.deleteID).length > 0) {
					let id = this.deleteID;
					this.onCancel();
					this.$http.post(this.config.api + "/admin/referral/disable", {
						id: id,
					}).then(res => {
						this.searchHandler();
					})
				} else {
					this.deleteID = id;
					this.deleteDialog = true;
				}
			},
			checkValidation() {
				if (String(this.referral.name).length > 0 && String(this.name_khmer).length > 0 && String(this.referral.phone).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			onCancel() {
				this.deleteID = "";
				this.deleteDialog = false;
			},
			clearAll() {
				this.search.text = "";
				this.referral = {
					name: "",
					phone: "",
					description: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Referral/View.vue